import { useWebsiteButton } from "../../customeHooks/useWebsiteButtons";
import { ComparisonTableSection } from "./components/comparisonTableSection";
import { CtaSection } from "./components/ctaSection";
import { FaqSection } from "./components/faqSection";
import { FindEventsSection } from "./components/findEventsSection";
import { Hero } from "./components/hero";
import { TestimonialSection } from "./components/testimonialSection";
import { WhyChooseTikketSection } from "./components/whyChooseTikketSection";

export const LandingPage = ({
  isSignedIn,
  navbarHeight,
}: {
  isSignedIn: boolean;
  navbarHeight: number;
}) => {
  const { goToSignup, goToDashboard } = useWebsiteButton();

  const handleCreateEvent = () => {
    if (isSignedIn) {
      goToDashboard();
    } else {
      goToSignup();
    }
  };

  return (
    <div className="relative flex flex-1 flex-col">
      <Hero onCreateEvent={handleCreateEvent} navbarHeight={navbarHeight} />
      <FindEventsSection />
      <TestimonialSection />
      <WhyChooseTikketSection />
      <ComparisonTableSection />
      <FaqSection />
      <CtaSection onCreateEvent={handleCreateEvent} />
    </div>
  );
};
